<template>
  <section class="screen">
    <step-header step="select-sign" :hidden="editing" />

    <div class="s-body stack gap-10">
      <signature-pad ref="pad" @change="hasInk = $event" />
    </div>

    <div class="s-foot">
      <button class="btn btn-primary" type="button" :disabled="!hasInk" @click="confirm">
        تأیید امضا
      </button>
    </div>
  </section>
</template>

<script>
import StepHeader from "@/components/StepHeader.vue";
import SignaturePad from "@/components/SignaturePad.vue";

/**
 * Step 3 — the electronic signature.
 *
 * The lightest step by design: no camera, no countdown, nothing to get wrong. It sits
 * between the video and the review as a deliberate cool-down, and it is also why the
 * camera can stay released from here to the end of the flow.
 */
export default {
  name: "SelectSignView",
  components: { StepHeader, SignaturePad },

  data() {
    return { hasInk: false };
  },

  computed: {
    editing() {
      return this.$route.query.edit === "1";
    },
  },

  methods: {
    confirm() {
      const dataUrl = this.$refs.pad.toDataUrl();
      if (!dataUrl) return;
      this.$store.commit("flow/SET_SIGNATURE", dataUrl);
      this.$router.push({ name: "check-assets" });
    },
  },
};
</script>
